import { useQuery } from '@hooks/core';
import api from './api';

export const useMetals = () => {
  const { data: metals, isLoading: isMetalsLoading } = useQuery(api.getMetals, { initial: [] });

  return { metals, isMetalsLoading };
};
